<h1 [translateParams]="{ name: context.data.name || '' }"
    [translate]="context.isNewEntry ? 'environment_modal_title_create' : 'environment_modal_title_edit'"
    matDialogTitle>
</h1>
<form [formGroup]="form"
      (submit)="onSubmit()">

    <mat-dialog-content>
        <mat-form-field>
            <input [uiAutofocus]
                   [readonly]="!context.isNewEntry"
                   [placeholder]="'environment_modal_form_name' | translate"
                   matInput
                   formControlName="name"
                   name="name"
                   class="form-control"
                   required
                   data-cy="environment-name" />
            <mat-hint *ngIf="!form.get('name')!.pristine &&
                             form.get('name')!.hasError('maxlength')"
                      [translateParams]="{ max: form.get('name')!.getError('maxlength').requiredLength }"
                      translate
                      class="errorMessage">
                environment_modal_form_name_max_warning
            </mat-hint>
        </mat-form-field>
        <mat-form-field>
            <input [placeholder]="'environment_modal_form_description' | translate"
                   matInput
                   formControlName="description"
                   class="form-control"
                   data-cy="environment-description" />
            <mat-hint *ngIf="!form.get('description')!.pristine &&
                         form.get('description')!.hasError('maxlength')"
                      [translateParams]="{ max: form.get('description')!.getError('maxlength').requiredLength }"
                      translate
                      class="errorMessage">
                environment_modal_form_description_max_warning
            </mat-hint>
        </mat-form-field>
    </mat-dialog-content>

    <mat-dialog-actions *ngLet="{
                        loading: loading$ | async
                    } as state"
                        align="end">
        <button mat-dialog-close
                mat-button
                type="button"
                data-cy="environment-cancel">
            {{ 'modal_action_cancel' | translate }}
        </button>
        <button [spinnerButtonLoading]="state.loading"
                [disabled]="state.loading ||
                        form.invalid"
                ui-spinner-button
                mat-flat-button
                type="submit"
                color="primary"
                data-cy="environment-submit">
            {{ (context.isNewEntry ? 'modal_action_create' : 'modal_action_update') | translate }}
        </button>
    </mat-dialog-actions>
</form>
